/**
 * Created by rastwe on 3/14/2017.
 */

import {normalize} from '../util/utils';
import {modalLevels} from '../util/uiconstants';

/**
 * This file represents the initial state in the Redux store.
 * It's used to provide default values in the reducers, in cases
 * where the store doesn't yet have a value, and there are no
 * action matches in the reducer, so that the return value of
 * the reducer function will never be undefined.
 * Use this file to help give you an idea what the overall
 * picture of the Redux store looks like.
 */

const normalizedValue = normalize();

export default {
	account: {},
	accounts: {...normalizedValue},
	accountAssertions: [],
	accountDetails: {},
	activeAnnotation: null,
	annotations: {...normalizedValue},
	apponlinestate: {},
	appVersion: false,
	aresFormHeaders: {
		headers: {
			...normalizedValue
		},
		sections: {
			...normalizedValue
		}
	},
	aresFormDataByBodyTypeId: {},
	aresMyRiskFactorDescriptions: {
		riskFactors: {
			normalizedValue,
			byId: {},
			allIds: []
		},
		descriptions: {
			...normalizedValue
		}
	},
	aresLinkedDocuments: {},
	aresTaskDocuments: {
		documents: {
			...normalizedValue
		}
	},
	aresTaskRelatedDocuments: [],
	aresTaskDetails: {},
	aresTaskList: {
		...normalizedValue
	},
	assertions: {},
	assessRiskSummary: {},
	aiChatBotIntegrationParameters: {},

	bodiesSpecial: {
		metadata: {},
		scots: {
			...normalizedValue
		},
		controls: {
			...normalizedValue
		},
		risks: {
			...normalizedValue
		},
		itProcesses: {
			...normalizedValue
		},
		itRisks: {
			...normalizedValue
		},
		itControls: {
			...normalizedValue
		},
		wcgws: {
			...normalizedValue
		},
		itsoApplications: {
			...normalizedValue
		},
		itApplications: {
			...normalizedValue
		}
	},
	buildTasks: {},
	bulkRelate: {uploadDocumentIds: [], uploadDocuments: []},
	captureAnnotation: {
		imagesets: {}
	},
	clearRightSideSnapshotView: {},
	configurations: {},
	countries: [],
	countryStatus: {},
	connectivitystate: {},
	currentAccountSEM: {},
	contentUpdates: [],
	controlAttributes: {},
	controlsDetails: {},

	docHelperDocuments: {},
	documentId: null,
	documents: {
		byId: {},
		allIds: []
	},
	documentExtensions: [],
	duplicateDocuments: [],
	documentsLastModifiedInformation: [],

	errors: {},
	engagement: {},
	engagementId: null,
	engagementComments: {
		config: {},
		commentStatuses: {},
		filters: undefined,
		selectedCommentGuid: undefined,
		modalConfig: undefined
	},
	engagementHelixProjects: [],
	engagementMetaData: null,
	engagementUsersWithRoles: null,
	engagementUserForIndependence: {},
	entityDocuments: {...normalizedValue},
	engagementTeamMembers: [],
	estimates: {...normalizedValue},
	entityForms: [],
	filterData: {},
	filter: {
		isLoaded: false
	},
	financialStatement: {...normalizedValue},
	form: {},
	formBodies: {...normalizedValue},
	formBodyRelatedDocuments: [],
	formPrintData: {},
	formProfileData: {},
	formBodyDisplayData: {},
	formBodyDisplayDataForUpdating: {},
	formBodyDisplayDataNoStoreUpdate: {},
	formProfileUpdateData: {},
	formBodyData: [],
	formOverwriteData: {},
	formUsers: {},
	formActions: {
		documents: {...normalizedValue},
		selectedActions: {...normalizedValue},
		availableActions: [],
		risks: {...normalizedValue}
	},
	fourFortyGlDocuments: {},

	flowChart: {},
	flowCharts: {},
	flowchartStep: {},
	isFlowChartStepEditModelOpen: false,

	groupAudit: {
		accounts: {
			data: null,
			parameters: {
				pages: null,
				page: 1,
				totalEntityCount: null,
				pageSize: 20,
				searchString: ''
			}
		},
		assignedScopes: null,
		components: {
			data: null,
			parameters: {
				pages: null,
				totalEntityCount: null
			}
		},
		groupSnapshots: [],
		scopes: null,
		sections: null,
		snapshots: null,
		groupAuditDocumentUploadOn: {}
	},

	helixSnapshot: {},
	helixProjects: {},
	helixProjectFilterMetadata: {},
	helixAccountsMappingStatus: null,

	isAresView: false,
	serverPrintData: {},
	isDrawerMode: false,
	isTrackChangesView: false,
	isCompareResponsesView: false,
	isGuidedWorkFlowV2: false,
	hasBodyIdFilter: false,
	navigationFilter: null,
	independenceIndividualDocumentId: {},
	isMediaPlaying: false,
	isModalOpen: false,
	isADCModalOpen: false,
	modalLevel: modalLevels.defaultLevel,
	internalUsers: {},
	isStandaloneView: false,
	isValidUserWithProjectAvailable: {},
	independenceActionEngagementUser: {},
	itprocess: {},
	itapplication: {},
	itapplicationData: {},
	isLoading: false,
	itAppSODetails: {},
	itrisk: {},
	internalUser: {},
	itcontrolDetails: {},

	journalSource: {
		byId: {},
		allIds: []
	},
	knowledgeForms: {
		byId: {},
		allIds: []
	},
	languages: [],
	limitedRiskDocuments: {},

	manageObjects: {},
	manageAccount: {},
	manageAccounts: {...normalizedValue},
	markCompleteTasks: {
		tasks: {...normalizedValue},
		documents: {...normalizedValue}
	},
	materiality: {
		byId: {},
		allIds: []
	},
	multiEntity: {},

	navigationPanel: {},
	newRisk: {},

	offlinePrep: {},
	ovsProject: {isProjectAssociated: {}, isOtherProjectAssociated: {}, projects: []},
	paansUserData: {},
	pspIndexes: [],

	quickLink: [],

	relatedDocuments: {},
	relatedObjects: [],
	reviewNotes: {},
	relateTask: {...normalizedValue},
	roles: [],
	rbacRoles: [],
	risk: {},
	risks: {},
	riskTypes: {},
	riskFactors: {},
	rnhNoteDetail: {annotations: null, notesModalOpen: false, documentIds: {}},
	sampleList: {
		...normalizedValue
	},
	sampleItems: {
		...normalizedValue
	},
	sampleItemDocuments: {
		evidence: {},
		temporary: {},
		external: {}
	},
	signOffs: {
		...normalizedValue
	},
	sectionRelatedObjects: [],
	scot: {},
	scots: [],
	scotsDetails: {},
	snapshots: [],
	snapshotDetails: {},
	snapshotCompareDetails: {},
	showHideRightSideSnapshotView: {},
	showHideLeftSideSnapshotView: {},
	stEntities: {...normalizedValue},
	stEntityId: {},
	submitProfileDetails: {},

	tagItems: {
		tags: {...normalizedValue},
		tagGroups: {...normalizedValue}
	},
	taskList: {},
	timePhases: [],
	trialBalances: {...normalizedValue},
	trialBalance: {...normalizedValue},
	toasterDetails: {},
	topHeader: {},
	userPreferences: {isPreferencesLoaded: false},
	userPresence: {},
	uploadDocuments: {},
	userData: null,

	validations: {},
	validationdetails: {},
	withoutapprovalvalidations: {},

	wcgw: {},
	wcgws: [],
	wcgwRelatedRisks: {},
	relateRisks: {},
	wcgwTasks: {},
	workspaceEngagements: null,
	workspaceMetaData: {}
};
